export default "__VITE_ASSET__CUCO44RR__"